/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto. Keeping your custom
* Javascript in this file will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  document.addEventListener('DOMContentLoaded', function () {
    if (!window.theme || !window.theme.assets || !window.theme.assets.swatches || !window.theme.assets.base) {
      return;
    }

    fetch(window.theme.assets.swatches)
      .then(function (response) {
        return response.json();
      })
      .then(function (swatchesJson) {
        var swatchMap = {};
        var swatchMapLowercase = {};

        if (!swatchesJson.colors || !Array.isArray(swatchesJson.colors)) {
          return;
        }

        swatchesJson.colors.forEach(function (item) {
          var swatchName = Object.keys(item)[0];
          var swatchValue = item[swatchName];

          swatchMap[swatchName] = swatchValue;
          swatchMapLowercase[swatchName.toLowerCase()] = swatchValue;
        });

        function applySiblingSwatches() {
          document.querySelectorAll('.siblings__button[data-swatch]').forEach(function (button) {
            var swatchName = button.getAttribute('data-swatch');

            if (!swatchName) {
              return;
            }

            var swatchValue = swatchMap[swatchName] || swatchMapLowercase[swatchName.toLowerCase()];

            if (!swatchValue) {
              return;
            }

            if (swatchValue.indexOf('#') === 0 || swatchValue.toLowerCase() === 'black') {
              button.style.setProperty('--swatch', swatchValue);
              button.style.backgroundImage = '';
            } else {
              button.style.backgroundImage = 'url(' + window.theme.assets.base + swatchValue + ')';
              button.style.backgroundSize = 'cover';
              button.style.backgroundPosition = 'center center';
            }
          });
        }

        applySiblingSwatches();

        document.addEventListener('shopify:section:load', applySiblingSwatches);

        setTimeout(applySiblingSwatches, 500);
        setTimeout(applySiblingSwatches, 1500);
      })
      .catch(function (error) {
        console.warn('Could not load swatches.json for sibling swatches:', error);
      });
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();